import { DateTimeHelper } from '../../../../helpers/date-time.helper';
import type { ILinkEndpoint } from '../../../../models/link-endpoint.model';
import { LocationTypeHelper } from '../../../../models/location-type.enum';
import type { INote } from '../../../../models/note.model';

export class LinkEndpointApiModel {
  public static mapToBusinessModel(apiModel: LinkEndpointApiModel): ILinkEndpoint {
    return {
      gid: apiModel.gid,
      name: apiModel.name,
      locationType: LocationTypeHelper.parse(apiModel.locationType),
      latitude: apiModel.latitude,
      longitude: apiModel.longitude,
      plannedTime: DateTimeHelper.parse(apiModel.plannedTime),
      estimatedTime: apiModel.estimatedTime ? DateTimeHelper.parse(apiModel.estimatedTime) : undefined,
      notes: apiModel.notes,
    };
  }

  public gid?: string;
  public name!: string;
  public locationType!: string;
  public latitude?: number;
  public longitude?: number;
  public plannedTime!: string;
  public estimatedTime?: string;
  public notes!: INote[];
  public estimatedOtherwisePlannedTime?: string;
}
